// removed by extract-text-webpack-plugin
module.exports = {"contentFrame":"src-components-Layout----layout-module---contentFrame---10LR0","bodyFrame":"src-components-Layout----layout-module---bodyFrame---_9jBG","top":"src-components-Layout----layout-module---top---3NVBP","leftColumn":"src-components-Layout----layout-module---leftColumn---1W51B","rightColumn":"src-components-Layout----layout-module---rightColumn---1dJl7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/layout.module.css
// module id = 677
// module chunks = 6674870452060